<template>
  <div v-if="showSidePanel" class="side-panel bg-white px-8"
          style="z-index: 999;">
    <div class="side-panel__header-container pt-6">
      <div class="side-panel__header d-flex flex-row justify-space-between">
        <h5 class="text-gray">Fragenauswertung</h5>
        <v-icon @click.stop="close()">mdi-close</v-icon>
      </div>
      <v-divider class="mb-0"></v-divider>
    </div>
    <div class="side-panel__infos d-flex flex-row pt-8 pb-0">
      <v-card flat class="bg-gray px-8 py-4 full-width">
        <span style="color: var(--gray-color_1);">"{{questionEvaluation.questionText}}"</span>
      </v-card>
    </div>
    <v-col class="d-flex flex-row justify-space-around mx-0">
      <v-card flat class="evaluation-info full-width">
        <v-card-title class="evaluation-info-title">Durchschnittlicher Score</v-card-title>
        <span class=evaluation-info-text :style="'color: '+ getColor(questionEvaluation.averageRate)">{{questionEvaluation.averageRate}}</span>
      </v-card>
      <v-card flat class="evaluation-info justify-end full-width">
        <v-card-title class="evaluation-info-title">Durchschnittliche Antwort</v-card-title>
        <span class=evaluation-info-text>{{questionEvaluation.averageAnswer}}</span>
      </v-card>
    </v-col>
    <v-divider></v-divider>
    <div class="side-panel__chart-container">
      <span class="subtitle mx-4">Antwortverteilung</span>
      <div class="side-panel__chart">
       <v-row>
        <v-col class="mt-2">
          <BarChart :data="questionEvaluation"/>
        </v-col>
       </v-row>

      </div>
    </div>
    <v-divider></v-divider>
    <div class="side-panel__tree mx-4">
      <span class="subtitle">Durchschnittliche Antwortverteilung in Prozent</span>
        <v-col class="question-list__table d-inline-block font-s mt-4">
          <v-row class="border-bottom question-list__table__header">
            <v-col cols="6">Antwort</v-col>
            <v-col>Beantworter</v-col>
            <v-col>Prozentsatz</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[1]}}</v-col>
            <v-col>{{getScore(1)}}</v-col>
            <v-col>{{calcPercentageScore(1)}} %</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[2]}}</v-col>
            <v-col>{{getScore(2)}}</v-col>
            <v-col>{{calcPercentageScore(2)}} %</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[3]}}</v-col>
            <v-col>{{getScore(3)}}</v-col>
            <v-col>{{calcPercentageScore(3)}} %</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[4]}}</v-col>
            <v-col>{{getScore(4)}}</v-col>
            <v-col>{{calcPercentageScore(4)}} %</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[5]}}</v-col>
            <v-col>{{getScore(5)}}</v-col>
            <v-col>{{calcPercentageScore(5)}} %</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">{{matrixValues[6]}}</v-col>
            <v-col>{{getScore(6)}}</v-col>
            <v-col>{{calcPercentageScore(6)}} %</v-col>
          </v-row>
        </v-col>
    </div>
  </div>
</template>

<script>
import BarChart from './Charts/BarChart.vue';

export default {
  name: "PXSurveyEvaluationTrendDetail",
  components: {
    BarChart
},
  data() {
    return {
      showSidePanel: false,
      questionEvaluation: {},
      matrixValues: {
          1: "Trifft überhaupt nicht zu",
          2: "Trifft nicht zu",
          3: "Trifft eher nicht zu",
          4: "Trifft eher zu",
          5: "Trifft zu",
          6: "Trifft voll und ganz zu"
      },
    }
  },
  methods: {
    open(evals) {
      let evalData = [];
      evals.forEach(ev => {
        evalData.push({
            timestamp: ev.timestamp,
            scores: ev.evalData.scores,
            inverted: ev.evalData.inverted
          })
      });
      let ev = evals[evals.length - 1];
      this.questionEvaluation = {
          questionText: ev.evalData.questionText,
          questionId: ev.evalData.questionId,
          evalData: evalData,
          inverted: ev.evalData.inverted,
          averageRate: this.getAverageRate(ev.evalData.scores, ev.evalData.inverted),
          averageAnswer: this.getAverageAnswer(ev.evalData.scores, ev.evalData.inverted)
        }
        if(ev.evalData.inverted) this.questionEvaluation.questionText+= " (invertiert)"
      this.showSidePanel = true;
    },
    close() {
      this.showSidePanel = false;
    },
    getTrafficGreen(score) {
      if(score <= 2) return 'var(--green-color)';
      return '#D5D5D5';
    },
    getTrafficYellow(score) {
      if(score > 2 && score <= 4) return 'var(--yellow-color)';
      return '#D5D5D5';
    },
    getTrafficRed(score) {
      if(score >= 5) return 'var(--red-color)';
      return '#D5D5D5';
    },
    getScore(scoreVal){
      let score = 0;
      let evals = this.questionEvaluation.evalData.map(e => e.scores);
      if(this.questionEvaluation.inverted) scoreVal = 7-scoreVal;
      evals.forEach(elem => score += elem[scoreVal]);
      return score;
    },
    calcPercentageScore(scoreVal){
      let score = 0;
      let scoreCount = 0;
      let evals = this.questionEvaluation.evalData.map(e => e.scores);
      if(this.questionEvaluation.inverted) scoreVal = 7-scoreVal;
      evals.forEach(elem => {
        score += elem[scoreVal];
        scoreCount += Object.values(elem).reduce((a, b) => a + b)
      });
      return (100*(score/scoreCount)).toFixed(2);
    },
    getAverageRate(scores, inverted) {
      let sum = 0;
      let voter = 0;
      for (let score in scores) {
        sum += score * scores[score];
        voter += scores[score];
      }
      let rate = sum/voter;
      return rate.toFixed(1);
    },
    getAverageAnswer(scores, inverted) {
      let averageRate = this.getAverageRate(scores, inverted);
      if(inverted) averageRate =  (7-averageRate);
      averageRate = Math.round(averageRate);
      switch(averageRate){
        case 1:
          return this.matrixValues[1]
        case 2:
          return this.matrixValues[2]
        case 3:
          return this.matrixValues[3]
        case 4:
          return this.matrixValues[4]
        case 5:
          return this.matrixValues[5]
        case 6:
          return this.matrixValues[6]
      }
      
    },
    roundToNextHalf(num){
      return Math.round(num*2)/2;
    },
    getColor(data){
        if(data <=2) return "var(--green-color)";
        if(data <=4) return "var(--yellow-color)";
        return "var(--red-color)";
    },
  },
}
</script>

<style scoped>
.side-panel {
  position: fixed;
  width: 34vw;
  height: calc(100vh - 52px);
  right: 0;
  top: 52px;
  bottom: 0;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.12);
  overflow: auto;
}
.side-panel__header-container {
  position: sticky;
  top: 0;
  z-index: 99;
  background: #fff;
}
.side-panel__infos__date {
  font-size: 10px;
}
.evaluation-info {
  box-shadow: unset !important;
}
.evaluation-info-text {
  text-align: start;
  float: unset !important;
}
.subtitle {
  font-weight: 600;
  font-size: 0.8rem !important;
}
:deep .apexcharts-text {
  font-size: 10px !important;
}
.question-list__table__header {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--gray-color_3);
}
</style>